import { Component, Input, NgZone, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";

export enum DialogSize {
    Small,
    Normal,
    Large
}

@Component({
    selector: 'modal-dialog',
    templateUrl: './modalDialog.component.html',
    styleUrls: ['./modalDialog.component.css'],
    standalone: false
})
export class ModalDialogComponent {
    public visible: boolean = false;
    public dialogSize = DialogSize;

    @Input() public dialogId: string;
    @Input() public title: string = null;
    @Input() public okText: string = null;
    @Input() public cancelText: string = null;
    @Input() public showCloseButton: boolean = false;
    @Input() public size: DialogSize = DialogSize.Normal;
    @Input() public closeAccept: boolean = true;
    @Input() public ngStyle: { [klass: string]: any; } = null;

    @Output() public acceptEvent = new EventEmitter<void>();

    constructor(private zone: NgZone, private changeDetector: ChangeDetectorRef) {

    }
    public open(): void {
        this.zone.run(() => {
            this.visible = true;
            this.changeDetector.detectChanges();
        });
    }

    public accept(event: Event): void {
        if (event) event.stopPropagation();
        this.zone.run(() => {
            if (this.closeAccept) {
                this.visible = false;
            }
            this.changeDetector.detectChanges();
        });
        this.acceptEvent.emit();
    }

    public close(event: Event): void {
        if (event) event.stopPropagation();
        this.zone.run(() => {
            this.visible = false;
            this.changeDetector.detectChanges();
        });
    }

    public fastEventKilling(event: Event) {
        event.stopPropagation();
        var evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 1, 1, 1, 1, 1, false, false, true, false, 0, null);
        document.querySelector("body").dispatchEvent(evt);
    }
}